import { combineSlices, configureStore } from "@reduxjs/toolkit";

const rootReducer = combineSlices();

export const makeStore = (preloadedState) => {
  const store = configureStore({
    reducer: rootReducer,
    preloadedState,
  });

  return store;
};

export const store = makeStore();
